import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_GEN_AI_DEMO_IEAM_2 = {
  title: `Powered by our Gen AI Engine in Edge\nApplication Management,<span style="color: #BEE3FF;"> Tony simply\nexpresses his needs in plain English,</span> as if\ntalking to a colleague. The text field\nmakes sophisticated AI accessible to all,\nirrespective of technical expertise.`,
  subtitle: "ai ASSISTED demo",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_118"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_116"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_GEN_AI_Demo_01.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_02_BUBBLE_1.png",
          imageStyle: { alignSelf: "flex-end", marginTop: "0px" },
        },
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_02_BUBBLE_2.png",
          imageStyle: {
            alignSelf: "flex-start",
            marginLeft: "90px",
            marginTop: "21px",
          },
        },
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_02_BUBBLE_3.png",
          imageStyle: { alignSelf: "flex-end", marginTop: "22px" },
        },
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_02_BUBBLE_4.png",
          imageStyle: { alignSelf: "flex-start", marginLeft: "90px" },
        },
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_02_BUBBLE_5.png",
          imageStyle: { alignSelf: "flex-end", marginTop: "-20px" },
        },
      ]}
      pageNumber={"ENG_117"}
    />
  ),
};
